export function saveAs(data, filename, type) {
	const blob = new Blob([data], { type: type });

	const downloadUrl = window.URL.createObjectURL(blob);

	const a = document.createElement('a');
	a.href = downloadUrl;
	a.target = '_blank';
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
}
